var map = {
	"./Company.vue": [
		"8799",
		"chunk-2d21d159",
		"chunk-1aed45f2"
	],
	"./Contactus.vue": [
		"fe5b",
		"chunk-2d21d159",
		"chunk-5a3c4c3c",
		"chunk-7bbc640e"
	],
	"./ExpertThinkTank.vue": [
		"1e86",
		"chunk-2d21d159",
		"chunk-7b548cde"
	],
	"./Home.vue": [
		"bb51",
		"chunk-2d21d159",
		"chunk-5a3c4c3c",
		"chunk-78a59b50"
	],
	"./Journal.vue": [
		"baff",
		"chunk-2d21d159",
		"chunk-30ef124a"
	],
	"./JournalDetails.vue": [
		"310e",
		"chunk-5c50d4df"
	],
	"./JournalSubmit.vue": [
		"b913",
		"chunk-5c85c28a"
	],
	"./News/details.vue": [
		"6d83",
		"chunk-2d21d159",
		"chunk-5a3c4c3c",
		"chunk-1b0d8c7a"
	],
	"./News/index.vue": [
		"971a",
		"chunk-2d21d159",
		"chunk-5a3c4c3c",
		"chunk-df890e0c"
	],
	"./ProductService.vue": [
		"2e37",
		"chunk-2d21d159",
		"chunk-4f2b06ac"
	],
	"./Questionnaire/details.vue": [
		"b911",
		"chunk-2d21d159",
		"chunk-5a3c4c3c",
		"chunk-14b6b989"
	],
	"./Questionnaire/index.vue": [
		"213b",
		"chunk-2d21d159",
		"chunk-5a3c4c3c",
		"chunk-33bd88ba"
	],
	"./Recruit.vue": [
		"b5c1",
		"chunk-2d21d159",
		"chunk-5044efe2"
	],
	"./SchoolCooperation.vue": [
		"ef88",
		"chunk-2d21d159",
		"chunk-80712cc6"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;